import { Injectable } from '@angular/core';
import { IControlAuditSearchCriteria } from '@caslink/common-client';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { AuditHistoryDialogComponent } from '../audit-history-dialog/audit-history-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root'
})
export class AuditingService {
    public static $name: string = 'auditingService';

    constructor(
        private proxyService: ProxyService,
        private dialogService: MatDialog
    ) {
    }

    public getAuditingData(hardwareId: number, pager: CASLink.Infrastructure.Ui.ViewModel.PagerViewModel, locationId: number):
        angular.IPromise<CASLink.Ui.ViewModel.ControlAudit.ControlAuditHistoryViewModel> {
        return this.proxyService.request({
            data: pager,
            endPoint: 'controlAuditHistory',
            route: 'ecpm03HardwareHistory',
            routeParams: { hardwareId: hardwareId, locationId: locationId }
        }).as<CASLink.Ui.ViewModel.ControlAudit.ControlAuditHistoryViewModel>();
    }

    public getControlAuditList(query: IControlAuditSearchCriteria):
        angular.IPromise<CASLink.Ui.ViewModel.ControlAudit.ControlAuditHistoryViewModel> {
        const order = query.order[0] === query.order[0].toUpperCase() ? query.order : query.order[0].toUpperCase() + query.order.substr(1);
        const sort = (query.ascending) ? 0 : 1;
        const minDate = query.startDate != null ? query.startDate.toISOString() : null;
        const maxDate = query.endDate != null ? query.endDate.toISOString() : null;
        return this.proxyService.request({
            endPoint: 'controlAuditHistory',
            queryParams: {
                'searchCriteria.deviceId': query.deviceId,
                'searchCriteria.endDate': maxDate,
                'searchCriteria.locationId': query.locationId,
                'searchCriteria.moduleId': query.moduleId,
                'searchCriteria.pagingCriteria.includeTotalCount': query.includeTotalCount,
                'searchCriteria.pagingCriteria.skip': (query.page - 1) * query.limit,
                'searchCriteria.pagingCriteria.sortDirection': sort,
                'searchCriteria.pagingCriteria.sortExpressions': order,
                'searchCriteria.pagingCriteria.take': query.limit,
                'searchCriteria.startDate': minDate,
                'searchCriteria.wildcard': query.wildcard,
                'searchCriteria.customerId': query.customerId,
                'searchCriteria.source': query.source
            },
            route: 'getControlAuditList'
        }).as<CASLink.Ui.ViewModel.ControlAudit.ControlAuditHistoryViewModel>();
    }

    public setNote(controlAuditId: string, note: string):
        angular.IPromise<CASLink.Ui.ViewModel.ControlAudit.ControlAuditViewModel> {
        return this.proxyService.request({
            endPoint: 'controlAuditHistory',
            data: {
                note: note,
                controlAuditId: controlAuditId
            },
            route: 'setNote'
        }).as<CASLink.Ui.ViewModel.ControlAudit.ControlAuditViewModel>();
    }

    public removeNote(controlAuditId: string, controlAuditNoteId: string):
        angular.IPromise<CASLink.Ui.ViewModel.ControlAudit.ControlAuditViewModel> {
        return this.proxyService.request({
            endPoint: 'controlAuditHistory',
            routeParams: {
                controlAuditId: controlAuditId,
                controlAuditNoteId: controlAuditNoteId
            },
            route: 'removeNote'
        }).as<CASLink.Ui.ViewModel.ControlAudit.ControlAuditViewModel>();
    }

    public openAuditHistoryDialog(audit: CASLink.Ui.ViewModel.ControlAudit.ControlAuditViewModel)  {
        const dialogRef = this.dialogService.open(AuditHistoryDialogComponent, {
            data: {
                audit: audit
            }
        });

        dialogRef.afterClosed().toPromise().then((result: any) => {
            if (result != null) {
            }
        });

    }
}
